export const AUX_CONTAINER_SELECTOR = '.tox-tinymce-aux'

export const CHEVRON_SELECTOR = 'button.tox-tbtn[data-alloy-tabstop="true"]'

export const OVERFLOW_DRAWER_SELECTOR = '.tox-toolbar__overflow'

export const ARIA_EXPANDED_ATTRIBUTE = 'aria-expanded'
